import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import {
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import NoPlayerCard from "./NoPlayerCard";

const NoPlayerItem = ({
  sortedData = [],
}: {
  sortedData?: Record<string, any>[];
}) => {
  if (!sortedData?.length) {
    return (
      <Box sx={{ mt: spacing.Spacing.xl.$value, textAlign: "center" }}>
        <Typography sx={{ fontSize: typography.Size.Text.sm.$value }}>
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
      <Stack spacing={2}>
        {sortedData.map((item, index) => (
          <NoPlayerCard
            key={`${item.brand_id ?? "row"}-${index}`}
            brand_name={item.brand_name}
            brand_id={item.brand_id}
            brand_action_date={item.brand_action_date}
            gap={item.GAP}
            playersFtd={item.Players_FTD}
            dailyFtd={item.Daily_FTD}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default NoPlayerItem;
